module.exports = __webpack_public_path__ + "img/pages_cover.830a4d0b.webp";